import { Environment, EnvironmentInterface } from '@guardfinder/shared';

const currentEnvironment = (process.env['NG_APP_ENV'] as Environment) || Environment.LOCAL;

export const environment: EnvironmentInterface = {
    production: currentEnvironment === Environment.PRODUCTION,
    environment: currentEnvironment,
    apiUrl: process.env['NG_APP_API_URL'] || 'https://api.dev.example.com',
    website: process.env['NG_APP_WEBSITE_URL'] || 'https://dev.example.com',
    webappUrl: process.env['NG_APP_WEBAPP_URL'] || 'https://webapp.dev.example.com',
    tokenKey: currentEnvironment === Environment.PRODUCTION ? 'token_client' : 'token',
    googleMapsApiKey: process.env['NG_APP_GOOGLE_API_KEY'] || 'YOUR_KEY',
    googleMapsId: process.env['NG_APP_GOOGLE_MAPS_ID'] || 'your-map-id',
    firebaseConfig: {
        apiKey: import.meta.env['NG_APP_FIREBASE_API_KEY'],
        authDomain: import.meta.env['NG_APP_FIREBASE_AUTH_DOMAIN'],
        projectId: import.meta.env['NG_APP_FIREBASE_PROJECT_ID'],
        storageBucket: import.meta.env['NG_APP_FIREBASE_STORAGE_BUCKET'],
        messagingSenderId: import.meta.env['NG_APP_FIREBASE_MESSAGING_SENDER_ID'],
        appId: import.meta.env['NG_APP_FIREBASE_APP_ID'],
        measurementId: import.meta.env['NG_APP_FIREBASE_MEASUREMENT_ID']
    },
    sentryDsn: process.env['NG_APP_SENTRY_DNS_URL'] || 'https://<key>@sentry.io/<dev>'
};
